module.exports = __webpack_public_path__ + "static/yolcu-detail1-f142e86c84a93d1b91e0c3a14c0f1843.png";